import React from "react";

function TermsAndCondition() {
  return (
    <div className="policy-container">
      <div className="content">
        <h2>Terms and Conditions</h2>
        <p>
          These terms and conditions outline the rules and regulations for the
          use of Techvanto Academy’s Website.
          <br />
          By accessing this website we assume you accept these terms and
          conditions. Do not continue to use Techvanto Academy if you do not
          agree to take all of the terms and conditions stated on this page.
          <br />
          The following terminology applies to these Terms and Conditions,
          Privacy Statement and Disclaimer Notice and all Agreements: "User",
          “Client”, "You" and "Your" refers to you, the person logged on to this
          website and compliant to the Company’s terms and conditions. "The
          Company", "Ourselves", "We", "Our" and "Us", refers to our Company.
          "Party", "Parties", or "Us", refers to both the users and ourselves.
          All terms refer to the offer, acceptance and consideration of payment
          necessary to undertake the process of our assistance to the user in
          the most appropriate manner for the express purpose of meeting the
          users needs in respect of provision of the Company’s stated services,
          in accordance with and subject to the prevailing law of India. Any use
          of the above terminology or other words in the singular, plural,
          capitalization and/or he/she or they, are taken as interchangeable and
          therefore as referring to same.
        </p>
        <p>
          <br />
          <h3>Security Rules</h3>
          Users are prohibited to violate or threaten, without restriction, the
          protection of the website. Users are not permitted to-
          <ul>
            <li> Connect or login to a server or database.</li>

            <li>
              Try to define, find, test, and/or infringe protection or
              authentication mechanisms on a system or network flaw without
              proper authorisations.
            </li>
            <li>
              Attempts, whether by delivering a virus, 'Trojan Horse' to the
              server, overloading, bursting, mailbombing or collapsing, to mess
              with the activities of any user, host or network.
            </li>
            <li>
              Send electronic mail, containing ads and/or promotion of products
              or services, unsolicited.{" "}
            </li>
          </ul>
          Security violations of computers or networks can lead to civil or
          criminal liability. Techvanto Academy has the right to prosecute acts
          that include such offences, to investigate and to collaborate with law
          enforcement bodies and users implicated in such offences.
        </p>
        <p>
          <br />
          <h3>License</h3>
          Users may not use this website to transfer, publish, store or damage
          materials. Unless otherwise stated, Techvanto Pvt. Ltd. and/or its
          licensors own the intellectual property rights for all material on
          Techvanto Academy. All intellectual property rights are reserved. You
          may access this from Techvanto Academy for your own personal use
          subjected to restrictions set in these terms and conditions.
          <ul>
            <li>Republish material from Techvanto Academy</li>
            <li>Sell, rent or sub-license material from Techvanto Academy</li>
            <li>
              Reproduce, duplicate or copy material from Techvanto Academy
            </li>
            <li>Redistribute content from Techvanto Academy</li>
          </ul>
          Parts of this website offer an opportunity for users to post and
          exchange opinions and information in certain areas of the website.
          Techvanto Academy does not filter, edit, publish or review comments
          made by a user on the website. Reviews do not reflect the views and
          opinions of Techvanto Academy, its agents and/or affiliates but those
          of the person who post their views and opinions. To the extent
          permitted by applicable laws, Techvanto Academy shall not be liable
          for the reviews or for any liability, damages or expenses caused
          and/or suffered as a result of any use of and/or posting of and/or
          appearance of the reviews on this website.
          <br />
          Techvanto Academy reserves the right to monitor all reviews and to
          remove any reviews which can be considered inappropriate, offensive or
          causes breach of these Terms and Conditions.
          <br />
          The user warrants and represents that:
          <ul>
            <li>
              The user is entitled to post reviews on our website and have all
              necessary licenses and consents to do so;
            </li>
            <li>
              The user will not invade any intellectual property right,
              including without limitation copyright, patent or trademark of any
              third party;
            </li>
            <li>
              The user will not post/misrepresent material that is defamatory,
              libellous, offensive, indecent or otherwise unlawful material
              which is an invasion of privacy;
            </li>
            <li>
              The user will not solicit or promote business, present commercial
              activities or unlawful activity.
            </li>
          </ul>
          The user hereby grants Techvanto Academy a non-exclusive license to
          use, reproduce, edit and authorize others to use, reproduce and edit
          any of your reviews in any and all forms, formats or media.
        </p>
        <p>
          <br />
          <h3>Indemnity</h3>
          Unilaterally, the user decides to indemnify and deny all claims,
          activities and/or claims and/or liability and/or negligence or damages
          arising out of use of our website/services/platform or breach of the
          terms and conditions. the Company, its officers, administrator,
          officers and agents.
        </p>
        <br />
        <h3>Hyperlinking to our Content</h3>
        <p>
          Organizations may link to our home page, to publications or to other
          Website information so long as the link: (a) is not in any way
          deceptive; (b) does not falsely imply sponsorship, endorsement or
          approval of the linking party and its products and/or services; and
          (c) fits within the context of the linking party’s site.
          <br />
          We may consider and approve other link requests from the following
          types of organizations:
          <ul>
            <li>
              commonly-known consumer and/or business information sources;
            </li>
            <li>dot.com community sites</li>
            <li>online directory distributors;</li>
            <li>internet portals;</li>
            <li>educational institutions and trade associations.</li>
          </ul>
          We will approve link requests from organizations if we decide that:
          (a) the link would not make us look unfavorably to ourselves or to our
          accredited businesses; (b) the organization does not have any negative
          records with us; and (c) the link is in the context of general
          resource information.
          <br />
          If you are interested in linking to our website, you must inform us by
          sending an e-mail to info@techvanto.com. Please include your name,
          your organization name, contact information as well as the URL of your
          site, a list of any URLs from which you intend to link to our Website,
          and a list of the URLs on our site to which you would like to link.
          <br />
          Approved organizations may hyperlink to our Website as follows:
          <ul>
            <li>By use of our corporate name; or</li>
            <li>By use of the uniform resource locator being linked to; or</li>
            <li>
              By use of any other description of our Website being linked to
              that makes sense within the context and format of content on the
              linking party’s site.
            </li>
          </ul>
          No use of the company's logo or other artwork will be allowed for
          linking absent a trademark license agreement.
        </p>
        <p>
          <br />
          <h3>Inline Frames</h3>
          Without prior approval and written permission, you may not create
          iFrames around our Webpages that alter in any way the visual
          presentation or appearance of our Website.
        </p>
        <p>
          <br />
          <h3>Content Liability</h3>
          We shall not be held responsible for any content that appears on your
          Website. You agree to protect and defend us against all claims that
          arise on your Website. No link(s) should appear on any Website that
          may be interpreted as libellous, obscene or criminal, or which
          infringes, otherwise violates, or advocates the infringement or other
          violation of, any third party rights.
        </p>
        <p>
          <br />
          <h3>Your Privacy</h3>
          Please read Privacy Policy
        </p>

        <p>
          <br />
          <h3>Reservation of Rights</h3>
          We reserve the right to request that you remove all links or any
          particular link to our Website. You approve to immediately remove all
          links to our Website upon request. We also reserve the right to amend
          these terms and conditions and its linking policy at any time. By
          continuously linking to our Website, you agree to be bound to and
          follow these linking terms and conditions. Removal of links from our
          website
          <br />
          If you find any link on our Website that is offensive for any reason,
          you are free to contact and inform us at any moment. We will consider
          requests to remove links but we are not obligated to or so or to
          respond to you directly. We do not ensure that the information on this
          website is correct, we do not warrant its completeness or accuracy;
          nor do we promise to ensure that the website remains available or that
          the material on the website is kept up to date.
        </p>
        <p>
          <br /> <h3>Disclaimer</h3>
          To the maximum extent permitted by applicable law, we exclude all
          representations, warranties and conditions related to our website and
          the use of this website. Nothing in this disclaimer will:
          <ul>
            <li>
              Limit or exclude our or your liability for fraud or fraudulent
              misrepresentation;
            </li>
            <li>
              Limit any of our or your liabilities in any way that is not
              permitted under applicable law; or
            </li>
            <li>
              Exclude any of our or your liabilities that may not be excluded
              under applicable law.
            </li>
          </ul>
          The limitations and prohibitions of liability set in this Section and
          elsewhere in this disclaimer: (a) are subject to the preceding
          paragraph; and (b) govern all liabilities arising under the
          disclaimer, including liabilities arising in contract, in tort and for
          breach of statutory duty.
          <br />
          As long as the website and the information and services on the website
          are provided free of charge, we will not be liable for any loss or
          damage of any nature.
          <br />
          The Company shall assume no liability in case of unauthorised access,
          modification of user transmissions, data arising from any other matter
          by the user relating to the service including but not limited to the
          loss of benefit, use of data or other intangible content.
          <br />
          No losses, including but not limited to incidental and consequential
          damages or loss of income or harm to computer hardware or loss of
          knowledge or disruption of business arising from the use of our
          website/services/platform, would be accrued to the company.
          <br />
          Irrespective of any deliberate or negligent action by the user that
          leads to the suspension of services/account, the company shall not be
          responsible for any damage incurred by the same.
        </p>
      </div>
    </div>
  );
}

export default TermsAndCondition;
